<template>
  <v-snackbar 
    v-model="snackbar.active" 
    :timeout="snackbar.timeout"
  >
  {{ snackbar.message }}
    <template v-slot:actions>
      <v-btn
        color="blue"
        variant="text"
        @click="snackbar.active = false"
      >
        Schließen
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["snackbar"])
  }
}

</script>